import { render } from "./MyLogo.vue?vue&type=template&id=1ec1abb8"
const script = {}

import "./MyLogo.vue?vue&type=style&index=0&id=1ec1abb8&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__